var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.971977 6.50078C0.696312 6.77644 0.696312 7.22338 0.971977 7.49905L6.61904 13.1461C6.8947 13.4218 7.34164 13.4218 7.6173 13.1461C7.89297 12.8704 7.89297 12.4235 7.6173 12.1478L3.17526 7.7058L16.5299 7.7058C16.9198 7.7058 17.2358 7.38976 17.2358 6.99991C17.2358 6.61007 16.9198 6.29403 16.5299 6.29403L3.17526 6.29403L7.6173 1.85199C7.89297 1.57632 7.89297 1.12938 7.6173 0.853721C7.34164 0.578056 6.8947 0.578056 6.61904 0.853721L0.971977 6.50078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/PrevIcon.4d4ab1e7eb45845770c2b4ab36ed17b8.svg";
export { ForwardRef as ReactComponent };